import { IsOptional } from "class-validator";

export class EventRegistrationForWaitlistDto {
  @IsOptional()
  is_waitlist?: boolean;
}